import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=35c06705&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=35c06705&prod&lang=css"
import style1 from "./Layout.vue?vue&type=style&index=1&id=35c06705&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c06705",
  null
  
)

export default component.exports